import { useLiveQuery } from 'dexie-react-hooks';
import type { PurchaseOrder, Supplier } from '@sense/shared';
import { api } from './api';
import { db } from './db';
import { pullCatalog } from './sync';

export function useSuppliers(): Supplier[] | undefined {
  return useLiveQuery(() => db.suppliers.orderBy('name').toArray(), []);
}

/** Create or edit a supplier (online), then pull the catalog delta that carries it. */
export async function saveSupplier(input: { id?: number; name: string; phone?: string | null; gstin?: string | null; address?: string | null; terms_days?: number | null; active?: boolean }) {
  const r = await api<{ id: number }>('/api/suppliers', { method: 'POST', json: { active: true, ...input } });
  await pullCatalog();
  return r.id;
}

export async function listOrders(status?: 'open' | 'received' | 'cancelled'): Promise<PurchaseOrder[]> {
  const r = await api<{ orders: PurchaseOrder[] }>(`/api/purchase-orders${status ? `?status=${status}` : ''}`);
  return r.orders;
}

/** WhatsApp link to send a purchase order to the supplier. */
export function poWhatsApp(po: PurchaseOrder, supplier: Supplier | undefined, store: string, names: Map<number, { name: string; unit: string }>) {
  const lines = po.lines.map(([pid, q], i) => `${i + 1}. ${names.get(pid)?.name ?? `#${pid}`} × ${q / 1000} ${names.get(pid)?.unit ?? ''}`).join('\n');
  const text = `Purchase order ${po.po_no} from ${store}\n\n${lines}\n\nPlease confirm the delivery date. Thank you.`;
  const phone = (supplier?.phone ?? '').replace(/\D/g, '').slice(-10);
  return `https://wa.me/${phone ? `91${phone}` : ''}?text=${encodeURIComponent(text)}`;
}
